<section class="flex flex-col">
	<h4 class="m-0 mb-2">Cargá la compra del cliente 👇🏻</h4>

	<small class="font-light text-[9px] m-0 p-0">
		Ingresá el número de venta de Fudo, ejemplo: 2350.
	</small>

	<form [formGroup]="form" (submit)="onSubmit()">
		<div class="flex flex-col gap-1 my-5">
			<input
				pInputText
				id="saleId"
				type="number"
				class="border border-gray-300 rounded-md p-2 w-full"
				placeholder="Número de venta"
				formControlName="saleId"
			/>
		</div>

		<div class="flex justify-end gap-2">
			<button
				type="button"
				pButton
				severity="secondary"
				class="p-button-outlined"
				(click)="onClose()"
			>
				Cancelar
			</button>
			<button type="submit" pButton [disabled]="form.invalid">
				Guardar
			</button>
		</div>
	</form>
</section>
